import { NavLink, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

const NAV_SECTIONS = [
  {
    label: 'OPERATIONS',
    items: [
      { to: '/dashboard', label: 'Mission Control', roles: ['owner', 'manager', 'budtender', 'viewer'] },
      { to: '/admin/signal', label: 'The Signal', roles: ['owner', 'manager'] },
      { to: '/admin/signal-performance', label: 'Signal Performance', roles: ['owner'] },
      { to: '/admin/vendor-campaigns', label: 'Vendor Campaigns', roles: ['owner'] },
      { to: '/staff', label: 'Staff Orders', roles: ['owner', 'manager', 'budtender'] },
      { to: '/products', label: 'Products', roles: ['owner', 'manager', 'budtender'] },
      { to: '/sales-clock', label: 'Sales & Clock', roles: ['owner', 'manager'] },
      { to: '/ops', label: 'Ops Dashboard', roles: ['owner', 'manager'] },
      { to: '/tv', label: 'TV Control', roles: ['owner', 'manager'] },
      { to: '/intelligence', label: 'Intelligence', roles: ['owner', 'manager'] },
      { to: '/ai', label: 'AI Assistant', roles: ['owner', 'manager', 'budtender'] },
      { to: '/kb-analytics', label: 'KB Analytics', roles: ['owner'] },
      { to: '/admin/user-adoption', label: 'User Adoption', roles: ['owner'] },
      { to: '/attendance', label: 'Attendance', roles: ['owner', 'manager'] },
      { to: '/employees', label: 'Team Performance', roles: ['owner', 'manager'] },
      { to: '/daily-duties', label: 'Daily Duties', roles: ['owner', 'manager'] },
      { to: '/admin/inventory-errors', label: 'Inventory Errors', roles: ['owner'] },
      { to: '/admin/door-closures', label: 'Door Closures', roles: ['owner'] },
      { to: '/admin/rule-violations', label: 'Accountability Log', roles: ['owner', 'manager'] },
      { to: '/till-check', label: 'Till Check', roles: ['owner', 'manager'] },
      { to: '/admin/help-desk', label: 'Help Desk', roles: ['owner', 'manager'] },
      { to: '/admin/budtender', label: 'Budtender (Kiosk Orders)', roles: ['owner', 'manager', 'budtender'] },
      { to: '/admin/lottery', label: 'Lottery / Break-Open', roles: ['owner'] },
    ],
  },
  {
    label: 'WEBSITE',
    items: [
      { to: '/website', label: 'Dashboard', roles: ['owner', 'manager'] },
      { to: '/website/orders', label: 'Orders', roles: ['owner', 'manager'] },
      { to: '/website/holds', label: 'Inventory Holds', roles: ['owner', 'manager'] },
      { to: '/website/products', label: 'Products', roles: ['owner', 'manager'] },
      { to: '/website/customers', label: 'Customers', roles: ['owner', 'manager'] },
      { to: '/website/loyalty', label: 'Loyalty', roles: ['owner', 'manager'] },
      { to: '/website/content', label: 'Storefront', roles: ['owner', 'manager'] },
      { to: '/website/seo', label: 'SEO', roles: ['owner', 'manager'] },
      { to: '/website/analytics', label: 'Analytics', roles: ['owner', 'manager'] },
      { to: '/website/collections', label: 'Collections', roles: ['owner', 'manager'] },
      { to: '/website/discounts', label: 'Discounts', roles: ['owner', 'manager'] },
      { to: '/website/categories', label: 'Categories', roles: ['owner', 'manager'] },
      { to: '/website/theme', label: 'Theme', roles: ['owner', 'manager'] },
      { to: '/website/settings', label: 'Settings', roles: ['owner', 'manager'] },
      { to: '/website/code', label: 'Code Editor', roles: ['owner'] },
      { to: '/website/templates', label: 'Templates', roles: ['owner', 'manager'] },
      { to: '/klaviyo', label: 'Campaign Builder', roles: ['owner'] },
    ],
  },
  {
    label: 'SUPPLY CHAIN',
    items: [
      { to: '/ordering', label: 'Ordering', roles: ['owner', 'manager'] },
      { to: '/photo-cards', label: 'Photo Cards', roles: ['owner', 'manager'] },
      { to: '/receiving', label: 'Receiving', roles: ['owner', 'manager'] },
      { to: '/stockouts', label: 'Stockouts', roles: ['owner', 'manager'] },
      { to: '/purchase-orders', label: 'Purchase Orders', roles: ['owner', 'manager'] },
      { to: '/products/onboarding', label: 'Onboarding', roles: ['owner', 'manager'] },
      { to: '/out-of-stock', label: 'Out of Stock', roles: ['owner', 'manager', 'budtender'] },
      { to: '/mbll-catalog', label: 'MBLL Catalog', roles: ['owner', 'manager'] },
      { to: '/inventory-depth', label: 'Inventory Depth', roles: ['owner'] },
      { to: '/admin/customer-requests', label: 'Customer Requests', roles: ['owner', 'manager'] },
    ],
  },
  {
    label: 'REPORTS',
    items: [
      { to: '/reports', label: 'Reports Hub', roles: ['owner', 'manager'] },
      { to: '/reports/sales', label: 'Sales', roles: ['owner', 'manager'] },
      { to: '/reports/financial', label: 'Financial', roles: ['owner'] },
      { to: '/reports/inventory', label: 'Inventory', roles: ['owner', 'manager'] },
      { to: '/reports/customers', label: 'Customers', roles: ['owner', 'manager'] },
      { to: '/reports/budtender', label: 'Budtender Scorecard', roles: ['owner', 'manager'] },
    ],
  },
  {
    label: 'SYSTEMS',
    items: [
      { to: '/pos', label: 'POS Terminal', roles: ['owner', 'manager'] },
      { to: '/website-preview', label: 'Website Preview', roles: ['owner', 'manager'] },
      { to: '/cigar-club', label: 'Cigar Club', roles: ['owner', 'manager'] },
      { to: '/hive-nc', label: 'Hive NC', roles: ['owner', 'manager'] },
      { to: '/hive-accessories', label: 'Hive Accessories', roles: ['owner', 'manager'] },
      { to: '/jg-catalog', label: 'Jupiter Grass Catalog', roles: ['owner', 'manager'] },
      { to: '/competitors', label: 'Intel / Competitors', roles: ['owner'] },
      { to: '/cockpit', label: 'Cockpit', roles: ['owner'] },
    ],
  },
  {
    label: 'INTEGRATIONS',
    items: [
      { to: '/integrations/cova', label: 'Cova Reports', roles: ['owner', 'manager'] },
      { to: '/integrations/wiw', label: 'When I Work', roles: ['owner', 'manager'] },
      { to: '/integrations/nuclino', label: 'Nuclino KB', roles: ['owner', 'manager'] },
      { to: '/integrations/slack', label: 'Slack', roles: ['owner'] },
      { to: '/integrations/mbll', label: 'MBLL Reporting', roles: ['owner', 'manager'] },
      { to: '/integrations/woocommerce', label: 'WooCommerce', roles: ['owner', 'manager'] },
      { to: '/integrations/google', label: 'Google', roles: ['owner', 'manager'] },
      { to: '/integrations/webhooks', label: 'Webhooks', roles: ['owner'] },
      { to: '/integrations/sage', label: 'Sage Accounting', roles: ['owner'] },
    ],
  },
  {
    label: 'PLATFORM',
    items: [
      { to: '/projects', label: 'Projects', roles: ['owner'] },
      { to: '/admin/agents', label: 'Agent Fleet', roles: ['owner'] },
      { to: '/admin/agent-actions', label: 'Agent Actions', roles: ['owner'] },
      { to: '/platform/health', label: 'Health Monitor', roles: ['owner'] },
      { to: '/platform/apps', label: 'Apps', roles: ['owner'] },
      { to: '/platform/deployments', label: 'Deployments', roles: ['owner'] },
      { to: '/platform/backups', label: 'Backups', roles: ['owner'] },
      { to: '/platform/code', label: 'Codebase', roles: ['owner'] },
      { to: '/platform/audit', label: 'Audit Log', roles: ['owner', 'manager'] },
      { to: '/platform/activity', label: 'Activity Feed', roles: ['owner', 'manager'] },
    ],
  },
  {
    label: 'HR',
    items: [
      { to: '/hr/hiring', label: 'Hiring Pipeline', roles: ['owner', 'manager'] },
      { to: '/hr/training', label: 'Training Dashboard', roles: ['owner', 'manager'] },
      { to: '/hr/training-editor', label: 'Training Editor', roles: ['owner', 'manager'] },
      { to: '/hr/training-quiz-editor', label: 'Quiz Editor', roles: ['owner', 'manager'] },
      { to: '/hr/advanced-module-editor', label: 'Module Editor', roles: ['owner', 'manager'] },
      { to: '/hr/duties-editor', label: 'Duties Editor', roles: ['owner', 'manager'] },
      { to: '/admin/employee-manual', label: 'Employee Manual', roles: ['owner', 'manager'] },
    ],
  },
  {
    label: 'ADMIN',
    items: [
      { to: '/admin/staff', label: 'Staff', roles: ['owner'] },
      { to: '/payroll', label: 'Payroll', roles: ['owner'] },
      { to: '/admin/employee-info', label: 'Employee Info', roles: ['owner'] },
      { to: '/admin/payments', label: 'Payments', roles: ['owner'] },
      { to: '/admin/profitability', label: 'Profitability', roles: ['owner'] },
      { to: '/admin/change-float', label: 'Change Float', roles: ['owner'] },
      { to: '/admin/themes', label: 'Themes', roles: ['owner', 'manager', 'budtender', 'viewer'] },
      { to: '/dev', label: 'Dev Dashboard', roles: ['owner'] },
    ],
  },
];

interface SidebarProps {
  onClose?: () => void;
}

export default function Sidebar({ onClose }: SidebarProps) {
  const user = useAuthStore((s) => s.user);
  const role = user?.role || '';
  const location = useLocation();

  return (
    <aside className="w-60 bg-white flex flex-col h-full border-r border-gray-200">
      {/* Logo + mobile close */}
      <div className="p-5 border-b border-gray-200 flex items-center justify-between">
        <div>
          <div className="text-2xl font-bold font-mono tracking-[0.3em] text-gray-900">
            ESPER
          </div>
          <div className="text-[10px] tracking-[0.2em] text-gray-400 mt-1 font-mono">
            JUPITER CANNABIS
          </div>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="md:hidden p-1 text-gray-400 hover:text-gray-600"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-3 overflow-y-auto">
        {NAV_SECTIONS.map((section) => {
          const visible = section.items.filter((item) => item.roles.includes(role));
          if (visible.length === 0) return null;
          return (
            <div key={section.label} className="mb-2">
              <div className="px-4 py-2 text-[10px] tracking-[0.15em] text-gray-400 font-mono">
                {section.label}
              </div>
              {visible.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={onClose}
                  className={({ isActive }) =>
                    `flex items-center gap-2 mx-2 px-3 py-2 rounded text-xs font-mono transition-colors ${
                      isActive
                        ? 'bg-gray-100 text-gray-900 border-l-2 border-[#7473A9]'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 border-l-2 border-transparent'
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span className={`w-1.5 h-1.5 rounded-full ${isActive ? 'bg-[#7473A9]' : 'bg-gray-300'}`} />
                      {item.label}
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-200 text-[9px] text-gray-400 font-mono tracking-wider">
        ESPER v1.0
      </div>
    </aside>
  );
}
